module.exports = __webpack_public_path__ + "static/media/ProximaNova-Bold.72b6f2c9.otf";